(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('purchPriceUpdate', {
        templateUrl: 'views/components/views/purchPriceUpdate/purchPriceUpdate.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', '$q', '$timeout', 'utilityService', 'modalService', 'purchPriceUpdateService', function ($stateParams, $q, $timeout, utilityService, modalService, purchPriceUpdateService) {

            // #region VARIABLES & DEFINITIONS

            var vm = this;

            vm.model = {
                argType: $stateParams.argtype,
                argValue: $stateParams.argvalue,
                settingPurchasePriceUpdate: {},
                gridReady: false,
                progressInfo: {
                    label: '',
                    plabel: '',
                    field: '',
                    remField: '',
                    min: 0,
                    max: 100,
                    step: 0,
                    finishclose: ''
                },
                runProgress: ''
            };

            vm.grid = {
                dataTask: {
                    rememberId: '',
                    loadSetupId: null,
                    loadData: {},
                    addRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    removeRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    saveData: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    }
                },
                translations: [],
                config: {
                    editColumns: [
                        { key: 'price_val' },
                        { key: 'valuta_id' },
                        { key: 'suppliers_prodno' },
                        { key: 'fullprice_val' },
                        { key: 'discount_pst' }
                        //'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
                    ],
                    toolbar: {
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        buttons: [
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'test', text: '', func: function () { testItems(); } },
                            { name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                            //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                            //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                            //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                        ]
                    },
                    fixedHeader: true,
                    keepSortOnAdd: false,
                    keepSortOnCheckbox: false,
                    keepSortOnIsSelected: false,
                    rowClick: false,
                    specialFunc: {
                        newTab: true,
                        buttons: [
                            //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
                    css: {
                        altColor: true,
                        textWrapping: false
                    },
                    onDataSourceChanges: function (e) {
                        //console.log('onDataSourceChanges');
                        //console.dir(e);
                    }
                },
                kendo: {
                    height: '100%',
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    //persistSelection: false,
                    filterable: false
                },
                optionfunc: function (data) { optionfunc(data.data); },
                gridfunc: null
            };

            var optionfunc = function (data) {
                //console.log('optionfunc');
                //if (angular.isDefined(data.func) && data.func === 'CellClickHandler') {
                //    console.log('optionfunc - CellClickHandler');
                //    console.dir(data);
                //}

                //if (angular.isDefined(data.func) && data.func === 'OnCellClose') {
                //    console.log('optionfunc - OnCellClose');
                //    console.dir(data);
                //}

                //if (angular.isDefined(data.func) && data.func === 'LookupCellEditor') {
                //    console.log('optionfunc - LookupCellEditor');
                //    console.dir(data);
                //}
            };

            // #endregion VARIABLES & DEFINITIONS

            //#region SHOW DIALOGUE BOX FUNCTION

            var showMessage = function (type, title, message, label, cssClass) {
                var deferred = $q.defer();

                modalService.show({
                    type: type || 'warning',
                    title: title || '',
                    message: message,
                    buttons: [{
                        label: label || 'OK',
                        cssClass: cssClass || 'btn-warning',
                        action: function (dialogItself) {
                            dialogItself.close();
                            deferred.resolve();
                        }
                    }]
                });

                return deferred.promise;
            };

            //#endregion SHOW DIALOGUE BOX FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            purchPriceUpdateService.getPurchasePriceUpdate({
                argtype: vm.model.argType,
                argvalue: vm.model.argValue
            }).then(function (data) {
                angular.copy(data[0], vm.model.settingPurchasePriceUpdate);

		        if (utilityService.validateParmsValue(vm.model.settingPurchasePriceUpdate.view_id) === true) {
		        	vm.grid.dataTask.rememberId = vm.model.settingPurchasePriceUpdate.view_id;
		        }

		        if (utilityService.validateParmsValue(vm.model.settingPurchasePriceUpdate.p2_datatask_keyno) === true) {
		        	vm.grid.dataTask.loadData = {
		        		method: vm.model.settingPurchasePriceUpdate.p2_datatask_keyno,
		        		parameters: vm.model.settingPurchasePriceUpdate
		        	};
		        }

		        vm.model.gridReady = true;
            });

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region SAVE PROCEDURE FUNCTION CALL

            var saveItems = function () {
                progressFuncSave();
            };

		    // #endregion SAVE PROCEDURE FUNCTION CALL

            // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            vm.activateProgressSave = function (items) {
                var increment = 1, skip = 0, failed = 0, step = 0;
                vm.model.progressInfo.step = 0;

                var doStep = function () {
                    $timeout(function () {
                        modalService.progressInfo.finishclose = '0';

                        if (vm.model.runProgress === 'ABORT') return;

                        if (vm.model.progressInfo.step >= vm.model.progressInfo.max) {
                            return;
                        }

                        step = vm.model.progressInfo.step + skip + failed;
                        vm.model.progressInfo.field = 'ID: ' + items[step].purchprice_keyno;
                        modalService.progressInfo.field = vm.model.progressInfo.field;

                        purchPriceUpdateService.saveGrid(items[step]).then(function (data) {
                            if (data[0].errorcode !== '0') {
                                showMessage('warning', 'Varsel', data[0].errormessage, 'OK', 'btn-warning').then(function () {
                                    modalService.progressInfo.finishclose = '1';
                                    vm.model.runProgress = 'ABORT';
                                    modalService.progressInfo.abortclose = true;

                                    doStep();
                                });
                            } else {
                                vm.model.progressInfo.step += increment;
                                modalService.progressInfo.step = vm.model.progressInfo.step;
                                modalService.progressInfo.finishclose = vm.model.progressInfo.finishclose;

                                doStep();
                            }
                        });
                    });
                };

                doStep();
            };

            var progressFuncSave = function () {
                vm.model.runProgress = 'START';
                vm.model.progressInfo.label = 'progressbar';
                //vm.model.progressInfo.plabel = 'progressbar';
                vm.model.progressInfo.field = '';
                //vm.model.progressInfo.remField = '';
                //vm.model.progressInfo.min = 0;
                vm.model.progressInfo.max = 0;
                vm.model.progressInfo.step = 0;
                vm.model.progressInfo.finishclose = '1';
                vm.model.progressInfo.abortclose = false;

                var dirtyRows = vm.grid.gridfunc.getDirtyRows();
                vm.model.progressInfo.max = dirtyRows.length;
                vm.activateProgressSave(dirtyRows);

                modalService.showProgress(vm.model.progressInfo).then(function (value) {
                    vm.model.runProgress = value;

                    if (vm.model.runProgress === 'FINISH') {
                        vm.grid.dataTask.loadData = {
                            method: vm.model.settingPurchasePriceUpdate.p2_datatask_keyno,
                            parameters: vm.model.settingPurchasePriceUpdate
                        };

                        vm.grid.gridfunc.rebind();
                    }
                });
            };

		    // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION
        }]
    });
})();
